export const SERVER_ADDRESS = "https://api.ctf.zer0pts.com/";
